// Main Function to Add Items to Cart
window.customAdd = async ({ id, quantity = 1, ele, mode }) => {
  if (!id) {
    console.warn('Variant ID is required to add to cart.');
    if (mode === 'mobile') {
      ele = document.querySelector('.plp.quick-buy-modal');
      if (ele) {
        const productSizeContainer = ele.querySelector('.product-size_container');
        const addToBagButton = ele.querySelector('.add-to-bag .addtobag');
        const addToBagContainer = ele.querySelector('.add-to-bag');
        const addToBagDisabled = ele.querySelector('.add-to-bag .add-to-bag-disabled');
        if (productSizeContainer) {
          productSizeContainer.classList.add('size-not-selected');
        }

        if (addToBagButton) {
          addToBagButton.classList.add('hidden');
        }

        if (addToBagContainer) {
          addToBagContainer.classList.add('disabled');
        }

        if (addToBagDisabled) {
          addToBagDisabled.classList.remove('hidden');
        }
      }
    }
    return;
  }

  const cart = document.querySelector('cart-popup');
  const cartDrawerWrapper = document.querySelector('cart-drawer');

  ele = mode === 'mobile' ? document.querySelector('.plp.quick-buy-modal .add-to-bag') : ele;

  if (ele) {
    handleLoadingState(ele, true, mode);
  }

  try {
    const addedItem = await addItemToCart(id, quantity);
    if (!addedItem) return;

    if (!cart) {
      redirectToCart();
      return;
    }

    await updateCartContent(cart, addedItem);
    if (cart) {
      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: 'product-form',
        cartData: addedItem,
      });
    }
  } catch (error) {
    console.error('Error processing cart update:', error);
  } finally {
    if (ele) {
      handleLoadingState(ele, false, mode);

      // Close the modal if it was opened in mobile mode
      if (mode === 'mobile') {
        const qmodal = document.querySelector('.plp.quick-buy-modal');
        if (qmodal) qmodal.classList.remove('active');
      }
    }

    cleanUpCartState(cart, cartDrawerWrapper);
  }
};

// Helper Function to Handle Loading State
function handleLoadingState(ele, isLoading, mode) {
  ele.setAttribute('aria-disabled', isLoading.toString());
  toggleSpinner(ele, isLoading);

  const targetElements =
    mode === 'mobile' ? ele.parentElement.querySelectorAll('.qb-button') : ele.querySelectorAll('li');

  toggleElements(targetElements, isLoading);
}

function toggleSpinner(ele, isLoading) {
  const spinner = ele.querySelector('.loading__spinner');
  if (spinner) spinner.classList.toggle('hidden', !isLoading);
}

function toggleElements(elements, hide) {
  elements.forEach((item) => item.classList.toggle('hidden', hide));
}

// Helper Function to Add Item to Cart
async function addItemToCart(id, quantity) {
  let payload = { items: [{ id: parseInt(id), quantity }] };
  if (window.privateSale || window.initialPrivateSaleAccess) payload.items[0].properties = { PrivateSale: 'Segmented' };
  const config = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
    },
    body: JSON.stringify(payload),
  };

  const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, config);
  const data = await response.json();

  if (data.status) {
    handleCartError(data, id);
    return null;
  }

  return data.items?.[0];
}

// Handle Cart Errors
function handleCartError(data, id) {
  publish(PUB_SUB_EVENTS.cartError, {
    source: 'product-form',
    productVariantId: id,
    errors: data.errors || data.description,
    message: data.message,
  });
  console.error('Error adding product:', data.errors || data.message);
}

// Helper Function to Redirect to Cart
function redirectToCart() {
  window.location.href = window.routes.cart_url;
}

// Helper Function to Update Cart Content
async function updateCartContent(cart, addedItem) {
  const sectionsResponse = await fetch(getSectionsUrl(cart));
  const sectionsData = await sectionsResponse.json();

  addedItem.sections = sectionsData;
  cart.renderContents(addedItem);
}

// Build URL for Sections to Render
function getSectionsUrl(cart) {
  const sections = cart
    .getSectionsToRender()
    .map((s) => s.id)
    .join(',');
  return `${window.Shopify.routes.root}?sections=${sections}`;
}

// Clean up Cart State After Processing
function cleanUpCartState(cart, cartDrawerWrapper) {
  if (cart?.classList.contains('is-empty')) {
    cart.classList.remove('is-empty');
  }

  if (cartDrawerWrapper?.classList.contains('is-empty', 'ob-cart-empty')) {
    removeCartDrawerClasses(cartDrawerWrapper, ['is-empty', 'ob-cart-empty']);
  }
}

// Main Function to Handle Mobile Modal
window.customMobAdd = async (pid, skus, colorSwatch, swatchImage, relatedSKUs) => {
  if (!pid) {
    console.warn('Product ID is required to display the modal.');
    return;
  }

  let ele = document.querySelector(`.collection-hero-product[data-product="${pid}"]`),
    hero = true;

  if (!ele) {
    ele = document.querySelector(`.result-item a[data-product="${pid}"]`);
    hero = false;
  }

  if (!ele) {
    console.error('Element not found for the given product ID.');
    return;
  }

  let additionalSKUs = null;

  if (relatedSKUs && hero == false) additionalSKUs = JSON.parse(relatedSKUs).map((item) => item.split('/').pop());

  if (hero) additionalSKUs = relatedSKUs;

  const productInfo = getProductInfo(ele);
  const qmodal = document.querySelector('.plp.quick-buy-modal');

  if (!qmodal) {
    console.error('Modal element not found.');
    return;
  }
  if (skus && skus.length) {
    populateModal(qmodal, productInfo, skus, pid, colorSwatch, swatchImage, additionalSKUs);
    qmodal.classList.add('active');
    qmodal.setAttribute('aria-hidden', 'false');
  }
};

// Helper Function to Get Product Info
function getProductInfo(ele) {
  if (ele.classList.contains('collection-hero-product')) {
    return {
      title: ele.querySelector('.hero-product-title').textContent,
      url: ele.getAttribute('href'),
      imageUrl: ele.querySelector('.collection-hero-product-img img')?.currentSrc,
      priceElement: ele.querySelector('.hero-product-price'),
    };
  }
  return {
    title: ele.getAttribute('title'),
    url: ele.getAttribute('href'),
    imageUrl: ele.querySelector('.is-snapped img, .is-in-view img, img.item-image')?.currentSrc,
    priceElement: ele.nextElementSibling.querySelector('.pricing div'),
  };
}

// Helper Function to Populate Modal Content
function populateModal(
  qmodal,
  { title, url, imageUrl, priceElement },
  skus,
  pid,
  colorSwatch,
  swatchImage,
  additionalSKUs
) {
  qmodal.setAttribute('prodid', pid);
  qmodal.setAttribute('data-product-name', title);
  qmodal.querySelector('.product-name').textContent = title;
  qmodal.querySelector('.view-details a').setAttribute('href', url);
  qmodal.querySelector('.product-image_container img').setAttribute('src', imageUrl);

  if (priceElement) {
    qmodal.querySelector('.add-to-bag .pricing').innerHTML = priceElement.innerHTML;
  }

  updateModalSizes(qmodal, skus, pid);
  updateModalColors(qmodal, colorSwatch, { pid, url, swatchImage }, additionalSKUs);
}

// Helper Function to Update Modal Sizes
function updateModalSizes(qmodal, skus, pid) {
  const sizeButtons = buildSizeButtons(skus, pid);
  const sizeContainer = qmodal.querySelector('.product-size .product-size_container');

  if (sizeButtons) {
    sizeContainer.innerHTML = sizeButtons;
    sizeContainer.parentElement.classList.remove('hidden');
    qmodal.querySelector('.add-to-bag').setAttribute('variantid', skus[0].id);
    qmodal.querySelector('.add-to-bag').setAttribute('onclick', `customAdd({ id: null, mode: 'mobile' })`);
  } else {
    sizeContainer.parentElement.classList.add('hidden');
  }
}

// Helper Function to Update Modal Colors
function updateModalColors(qmodal, colorSwatch, { pid, url, swatchImage }, additionalSKUs = []) {
  const swatchButtons = buildSwatchButtons(colorSwatch, { pid, url, swatchImage }, additionalSKUs);
  const colorContainer = qmodal.querySelector('.product-color');

  if (swatchButtons) {
    colorContainer.innerHTML = swatchButtons;
    colorContainer.classList.remove('hidden');
    if (!additionalSKUs || additionalSKUs.length === 0) return false;
    additionalSKUs.forEach((item) => {
      nostojs((api) => {
        api
          .search({
            query: item.toString(),
            products: {
              fields: ['name', 'availability', 'skus.inventoryLevel', 'skus.name', 'skus.availability'],
              size: 10,
            },
          })
          .then((response) => {
            let product = response.products.hits || [];
            if (product && product[0]?.availability != 'InStock') {
              document
                .querySelectorAll(`div.product-color__button.tile-color-swatch[prodid='${item}']`)
                .forEach((element) => {
                  element.classList.add('disable');
                  element.setAttribute('disabled', 'disabled');
                });
            }
          });
      });
    });
  } else {
    colorContainer.classList.add('hidden');
  }
}

// Helper Function to Build Size Buttons
function buildSizeButtons(skus, pid) {
  if (!skus || skus.length === 0) return false;

  // Start with the "Size" label as the first element
  let dynamicContent = '<span>Size</span>';

  skus.forEach((item, index) => {
    let buttonClass =
        index === 0 && item.inventoryLevel != 0 ? 'product-size__button qb-button' : 'product-size__button qb-button',
      disabledClass = item.inventoryLevel === 0 ? ' disabled' : '';
    buttonClass += disabledClass;

    dynamicContent += `<div class="${buttonClass}" data-variant-id="${item.id}" data-sizename="${item.name
      .split(' / ')
      .pop()}" prodid="${pid}" ${disabledClass}>${item.name.split(' / ').pop()}</div>`;
  });

  return dynamicContent;
}

// Helper Function to Build Swatch Buttons
function buildSwatchButtons(colorSwatch, { pid, url, swatchImage }, additionalSKUs = []) {
  if (!colorSwatch || !swatchImage || !additionalSKUs) return false;

  // Start with the "Color" label as the first element
  let dynamicContent = '<span>Colour</span>';

  if (colorSwatch && colorSwatch.length > 5 && additionalSKUs) {
    dynamicContent += this.createMoreSwatchesLink(colorSwatch.length - 4, url);
  }

  if (swatchImage) {
    dynamicContent += `
    <div class="product-color__button tile-color-swatch color-selected qb-button"
          data-linkurl="/products/${url}"
          prodid="${pid}"
          data-imgurl="${swatchImage}"
          data-pdpurl="/products/${url}">
        <img src="${swatchImage}" prodid="${pid}" data-pdpurl="/products/${url}" alt="${url}">
    </div>`;
  }

  if (colorSwatch && additionalSKUs) {
    colorSwatch.slice(0, 5).forEach((color, index) => {
      // Ensure `pid` is correctly assigned from `additionalSKUs`
      pid = additionalSKUs[index] || pid;
      dynamicContent += `
      <div class="product-color__button tile-color-swatch qb-button"
            data-linkurl="/products/${color.handle}"
            prodid="${pid}"
            data-imgurl="${color.image}"
            data-pdpurl="/products/${color.handle}">
          <img src="${color.image}" prodid="${pid}" data-pdpurl="/products/${color.handle}" alt="${color.handle}">
      </div>`;
    });
  }

  return dynamicContent;
}

function createMoreSwatchesLink(extraCount, url) {
  return `
        <div class="product-item-more">
            <a href="${url}" class="product-more_link">+${extraCount}</a>
        </div>`;
}

const buttonSwitchEvent = document.querySelector('.plp.quick-buy-modal .modal-content_body');

function getCustomFieldValue(customFields, key) {
  const field = customFields.find((field) => field.key == key);
  return field ? field.value : null;
}

var qmodal = document.querySelector('.plp.quick-buy-modal');
if (buttonSwitchEvent) {
  buttonSwitchEvent.addEventListener('click', (event) => {
    const targetElement = event.target;

    if (targetElement.hasAttribute('data-sizename') && targetElement.hasAttribute('data-variant-id')) {
      if (targetElement.hasAttribute('disabled')) return false;
      if (qmodal) {
        const productSizeContainer = qmodal.querySelector('.product-size_container');
        const addToBagButton = qmodal.querySelector('.add-to-bag .addtobag');
        const addToBagContainer = qmodal.querySelector('.add-to-bag');
        const addToBagDisabled = qmodal.querySelector('.add-to-bag .add-to-bag-disabled');
        if (productSizeContainer) {
          productSizeContainer.classList.remove('size-not-selected');
        }

        if (addToBagButton) {
          addToBagButton.classList.remove('hidden');
        }

        if (addToBagContainer) {
          addToBagContainer.classList.remove('disabled');
        }

        if (addToBagDisabled) {
          addToBagDisabled.classList.add('hidden');
        }
      }
      if (qmodal)
        qmodal
          .querySelector('.add-to-bag')
          .setAttribute(
            'onclick',
            `customAdd({ id: ${targetElement.getAttribute('data-variant-id')}, mode: 'mobile' })`
          );
      const sizeContainerButtons = qmodal.querySelectorAll('.product-size .product-size_container .qb-button');
      if (sizeContainerButtons) {
        sizeContainerButtons.forEach((element) => {
          element.classList.remove('size-selected');
        });
      }
      targetElement.classList.add('size-selected');
    }
    if (targetElement.hasAttribute('prodid') && targetElement.hasAttribute('data-pdpurl')) {
      if (targetElement.hasAttribute('disabled') || targetElement.parentElement.hasAttribute('disabled')) return false;
      const colorContainerButtons = qmodal.querySelectorAll('.product-color .qb-button');
      const productItem = targetElement.getAttribute('prodid');
      if (colorContainerButtons) {
        colorContainerButtons.forEach((element) => {
          element.classList.remove('color-selected');
        });
      }
      targetElement.parentElement.classList.add('color-selected');
      nostojs((api) => {
        api
          .search({
            query: productItem.toString(),
            products: {
              fields: [
                'name',
                'imageUrl',
                'url',
                'availability',
                'skus.inventoryLevel',
                'skus.name',
                'skus.availability',
                'skus.id',
              ],
              size: 10,
            },
          })
          .then((response) => {
            let product = response.products.hits[0] || [];
            if (product) {
              qmodal.querySelector('.product-image_container img').setAttribute('src', product.imageUrl);
              updateModalSizes(qmodal, product.skus, productItem);
              qmodal.querySelector('.view-details a').setAttribute('href', product.url);
            }
          });
      });
    }
  });
}

document.querySelector('.quick-buy-modal .close').addEventListener('click', function () {
  quickBuyDivclose();
});

const quickBuyDiv = document.querySelector('.quick-buy-modal');
if (quickBuyDiv) {
  const focusableElements = quickBuyDiv.querySelectorAll(
    'a, button, span, .product-size_container div, [tabindex]:not([tabindex="-1"])'
  );
  const firstFocusableElement = focusableElements[0];
  const lastFocusableElement = focusableElements[focusableElements.length - 1];

  quickBuyDiv.addEventListener('keydown', function (e) {
    if (e.key === 'Tab') {
      if (e.shiftKey) {
        // Shift + Tab
        if (document.activeElement === firstFocusableElement) {
          lastFocusableElement.focus();
          e.preventDefault();
        }
      } else {
        // Tab
        if (document.activeElement === lastFocusableElement) {
          firstFocusableElement.focus();
          e.preventDefault();
        }
      }
    } else if (e.key === 'Escape') {
      quickBuyDivclose(); // Function to close the modal
    }
  });

  function quickBuyDivclose() {
    quickBuyDiv.setAttribute('aria-hidden', 'true');
    quickBuyDiv.classList.remove('active');
  }
}
